import React from 'react'
import PropTypes from 'prop-types'
import { SedaFiltersForm } from '../../filters'
import { getPrefixLang } from '../../app/selectors/lang'
import { BasicSidePanel } from '../../../../shared'
import { useFilterStore } from '../../../filters'
import { Box, Button, Typography, withStyles } from '@material-ui/core'

const styles = theme => ({
  title: {
    ...theme.mixins.boldType,
    whiteSpace: 'nowrap',
    maxWidth: '100%',
    overflow: 'hidden'
  },
})

const PanelHeader = ({ classes }) => {
  const [filters, clearFilters] = useFilterStore(
    state => [state.filters, state.clearFilters]
  )

  const handleClearFilter = () => {
    clearFilters()
  }
  return(
    <Box
      width="100%"
      alignItems="center"
      display="flex"
      justifyContent="space-between"
      >
      <Typography className={classes.title}>
        {getPrefixLang('filter', 'PANEL_TITLE')}
      </Typography>
      <Button 
        variant="outlined"
        disabled={(filters.length === 0) ? true : false}
        onClick={handleClearFilter}>
          Reset Filters
      </Button>
    </Box>
  )
}

/**
 * Side panel for demographic selection
 */
const SedaFilterPanel = ({ classes, onClose, ...props }) => {
  return (
    <BasicSidePanel
      title={<PanelHeader classes={classes} />}
      onClose={onClose}
      {...props}>
      <SedaFiltersForm />
    </BasicSidePanel>
  )
}

SedaFilterPanel.propTypes = {
  onClose: PropTypes.func
}

export default withStyles(styles)(SedaFilterPanel)
